import React from "react";
import { Form } from "semantic-ui-react";

const CivilStatus = ({ data, loading, error, value, onChange }) => {
  if (loading) return (
    <Form.Dropdown
      fluid
      label="Estado civil"
      required
      loading
      selection
      placeholder="Estado civil *"
      options={[]} />
  );

  if (error) return (
    <Form.Dropdown
      fluid
      label="Estado civil"
      required
      error
      selection
      placeholder="Estado civil *"
      options={[]} />
  );
  const { estadoCivil } = data;

  return (
    <Form.Dropdown
      fluid
      label="Estado civil"
      required
      search
      value={value}
      selection
      onChange={onChange}
      placeholder="Estado civil *"
      options={estadoCivil} />
  );
}

export default CivilStatus;